"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchDoiSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.DoiSettingsActionTypes.LOAD_DOI_SETTINGS,
  requestStatusSelector: _selectors.getFetchDoiSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_ONCE,
  requestActions: _actions.FetchDoiSettings
}));
var updateDoiSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.DoiSettingsActionTypes.UPDATE_DOI_SETTINGS,
  requestStatusSelector: _selectors.getUpdateDoiSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateDoiSettings
}));

var _default = (0, _reduxObservable.combineEpics)(fetchDoiSettings, updateDoiSettings);

exports.default = _default;
module.exports = exports.default;